import React from 'react';
import { useTranslation } from 'react-i18next';
import { neededToApply } from '../lib/jobDocuments';

// Two-way switch on an employer's requested document: "Needed to apply" (blocks Submit) or
// "Needed if hired" (the seeker can apply now and bring it later). Shared by every job form.
const DocumentNeedToggle = ({ doc, onChange }) => {
  const { t } = useTranslation();
  const toApply = neededToApply(doc);
  const option = (value, label) => {
    const active = toApply === value;
    return (
      <button
        type="button"
        aria-pressed={active}
        onClick={() => { if (!active) onChange({ ...doc, required: value }); }}
        className={`min-h-[36px] px-2.5 text-xs font-medium whitespace-nowrap transition-colors ${
          active
            ? (value ? 'bg-red-600 text-white' : 'bg-emerald-600 text-white')
            : 'bg-white text-gray-600 hover:bg-gray-100'
        }`}
      >
        {label}
      </button>
    );
  };
  return (
    <div
      role="group"
      aria-label={t('jobDocs.whenNeeded', 'When is {{name}} needed?', { name: doc.name })}
      className="inline-flex shrink-0 overflow-hidden rounded-lg border border-gray-300 divide-x divide-gray-300"
      data-testid="document-need-toggle"
    >
      {option(true, t('jobDocs.toApply', 'To apply'))}
      {option(false, t('jobDocs.ifHired', 'If hired'))}
    </div>
  );
};

export default DocumentNeedToggle;
